import React, { Component } from 'react';
import { Icon } from 'antd-mobile';
import {parseSearchToState,coloseM} from '../../util/util';
import storage from 'store'
class NavBarComponent extends Component {
  state={
    show:false
  }
   
  showorHide(){
    let params=parseSearchToState(window.location.search);
    if(params['car-vs']||params.APPVersion){
      storage.set('channel','fromYueChe');
      storage.set('APPVersion',params['car-vs']?params['car-vs']:params.APPVersion);
    }
    if(params.channel=='fromRuJia'){
      storage.set('channel','fromRuJia');
    }
    if((storage.get('channel')=='fromYueChe'||storage.get('channel')=='fromRuJia' )&&(window.location.pathname=='/'|| window.location.pathname=='/my')){
      this.state.show=true
    }else{
      this.state.show=false
    }
  }
  render() {
    this.showorHide();
    return  <div style={{position: 'fixed', top: 0,width:'100%', zIndex: 2}}>
            {
                this.state.show&&
                <Icon  style={{position: 'absolute', top:'14px',left:'20px', zIndex: 3}} type='cross' onClick={()=>coloseM()}></Icon>
            } 
        {this.props.children}
    </div>
  }
}

export default NavBarComponent;